import React, { Component } from "react";
import Checkbox from "@mui/material/Checkbox";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { Link } from "react-router-dom";
class enterPhone extends Component {
  state = {
    PhoneNumber: "",
    checked:
      this.props.location.accept === undefined
        ? false
        : this.props.location.accept,
    error: "",
    loading: false,
    block: null,
  };
  render() {
    const SetPhoneNumber = ({ target }) => {
      const { value } = target;
      this.setState(
        {
          PhoneNumber: value,
        },
        () => {
          localStorage.setItem("phone", value);
        }
      );
    };

    const handleChange = (event) => {
      this.setState({ checked: event.target.checked });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      this.setState({ loading: true });
      const Headers = {
        Authorization: token(),
        "content-type": "application/json",
      };
      if (
        !/^(\+98|0)?9\d{9}$/.test(this.state.PhoneNumber) ||
        this.state.PhoneNumber < 11
      ) {
        this.setState({
          error: "فرمت شماره همراه اشتباه است",
          loading: false,
        });
      } else if (this.state.checked === false) {
        this.setState({
          error: "قوانین و شرایط استفاده را بپذیرید .",
          loading: false,
        });
      } else {
        axios
          .post(
            `${apiCall_domain}/customer/auth/chk_mobile`,
            { phone: this.state.PhoneNumber },
            {
              headers: Headers,
            }
          )
          .then((res) => {
            if (res.data.exists === 0) {
              this.props.history.push({
                pathname: "/checkCode",
              });
            } else if (res.data.exists === 1) {
              this.props.history.push({
                pathname: "/EnterPass",
              });
            }
          })
          .catch((error) => {
            this.setState({
              error: `${error?.response?.data?.errors[0]}  32843535-041`,
            });
            this.setState({ loading: false });
          });
      }
    };

    return (
      <>
        <div className="enterPhone">
          <div className="phoneBox">
            <div className="phoneTitle">شماره موبایل خود را وارد کنید</div>
            <input
              value={this.state.PhoneNumber}
              inputMode="numeric"
              className={`input ${
                !/^(\+98|0)?9\d{9}$/.test(this.state.PhoneNumber)
                  ? "hasError"
                  : ""
              }`}
              onChange={(e) => SetPhoneNumber(e)}
              placeholder="شماره موبایل را وارد کنید"
            />
            <div className="phoneRule">
              <Checkbox
                checked={this.state.checked}
                onChange={(e) => handleChange(e)}
                inputProps={{ "aria-label": "controlled" }}
              />
              <Link to={"/rulesAndConditions"} className="boldRules">
                قوانین و شرایط استفاده&nbsp;
              </Link>
              را خوانده و میپذیرم
            </div>
            <div className="error">{this.state.error}</div>
          </div>
          <img
            src="/public/assets/img/login/login.svg"
            alt="carousel"
            className="loginPic"
          />
          <div className="mySecContinueEnter">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={handleSubmit}>ادامه</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default enterPhone;
